// Shared prospect vocabulary used by BOTH the shop "My Service Area" board and
// the admin Zone dashboard so they render identical categories/statuses/colors.
export const CATS = [
  { key: "restaurant", label: "Restaurants" },
  { key: "coffee", label: "Coffee Shops" },
  { key: "brewery", label: "Breweries" },
  { key: "hotel", label: "Hotels" },
  { key: "attraction", label: "Attractions" },
];
export const CAT_LETTER = { restaurant: "R", coffee: "C", brewery: "B", hotel: "H", attraction: "A" };
export const CAT_LABEL = { restaurant: "Restaurant", coffee: "Coffee shop", brewery: "Brewery", hotel: "Hotel", attraction: "Attraction" };
export const STATUSES = ["New", "Called", "Interested", "Proposal Sent", "Approved & Paid", "Live", "Declined"];
export const STATUS_COLOR = {
  New: "#9ca3af", Called: "#eab308", Interested: "#3b82f6",
  "Proposal Sent": "#f97316", "Approved & Paid": "#22c55e", Live: "#14b8a6", Declined: "#ef4444",
};

export const fmtMoney = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const scoreColor = (s) =>
  s >= 75 ? "text-emerald-400" : s >= 50 ? "text-amber-400" : s >= 25 ? "text-sky-400" : "text-muted-foreground";

// Client mirror of backend opportunity.py (same weights & formula) so the board
// summary matches the server-computed listing columns exactly.
const MONTHLY_WEIGHTS = { restaurant: 30, coffee: 22, brewery: 28, hotel: 55, attraction: 15 };
const REVENUE_CATEGORIES = ["restaurant", "coffee", "brewery", "hotel"]; // attractions are not revenue-generating
export function computeOpportunity(prospects = []) {
  const by = { restaurant: 0, coffee: 0, brewery: 0, hotel: 0, attraction: 0 };
  prospects.forEach((p) => { if (by[p.category] != null) by[p.category] += 1; });
  const total = REVENUE_CATEGORIES.reduce((a, k) => a + by[k], 0);
  const monthly = REVENUE_CATEGORIES.reduce((s, k) => s + by[k] * MONTHLY_WEIGHTS[k], 0);
  const distinct = REVENUE_CATEGORIES.filter((k) => by[k] > 0).length;
  const score = total ? Math.round(Math.min(100, Math.min(80, (monthly / 2320) * 80) + distinct * 5)) : 0;
  return { prospectCount: total, byCategory: by, projectedMonthly: monthly, projectedAnnual: monthly * 12, opportunityScore: score };
}
